import type { ButtonHTMLAttributes, FC, MouseEvent } from 'react';

import { useAudioTrigger } from '../../../../../controllers/audioController/hooks';
import { useModifiers } from '../../../../../styles/hooks/useModifiers';

import styles from './AutoplayButton.module.css';

export interface AutoplayButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const AutoplayButton: FC<AutoplayButtonProps> = ({
  children,
  className,
  disabled = false,
  onClick,
  ...rest
}) => {
  const mods = useModifiers(styles, 'autoplayBtn', { disabled }, { withBaseClass: true, extraClassName: className });
  const audioTrigger = useAudioTrigger();

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    audioTrigger.play({ name: 'menuClick' });
    onClick?.(event);
  };

  return (
    <button className={mods} onClick={handleClick} {...rest}>
      <div className={styles.autoplayBtn__border} />
      <div className={styles.autoplayBtn__gradientLayer} />
      {children}
    </button>
  );
};
